import React from "react";
import { Modal } from "@arco-design/web-react";

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal with visible/onOk/
// onCancel/title; the Cancel/Delete DialogActions buttons become the Modal's
// okText/cancelText. Logic + props (count/render/onSave) are untouched.
export default function DeleteContactDialog({ count, render, onSave }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    onSave && onSave();
    handleClose();
  };

  return (
    <div>
      {render(handleClickOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        onOk={handleSave}
        title="Delete Contact"
        okText="Delete"
        cancelText="Cancel"
      >
        Are you sure you want to delete {count} contact
        {count > 1 && "s"}?
      </Modal>
    </div>
  );
}
